'use client';
function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
import { useState, useEffect } from 'react';
export function useLinkPreview(param) {
    var text = param.text;
    // 텍스트에서 감지된 URL 관리
    var _useState = _sliced_to_array(useState(null), 2), detectedUrl = _useState[0], setDetectedUrl = _useState[1];
    // 링크 미리보기 데이터 상태 (실제 API에서 가져올 예정)
    var _useState1 = _sliced_to_array(useState(null), 2), linkPreviewData = _useState1[0], setLinkPreviewData = _useState1[1];
    // URL 감지 함수
    var detectUrlFromText = function(text) {
        var urlRegex = /(https?:\/\/[^\s]+)/g;
        var matches = text.match(urlRegex);
        return matches ? matches[0] : null;
    };
    // 텍스트가 변경될 때 URL 감지
    useEffect(function() {
        var url = detectUrlFromText(text);
        // 새 URL이 감지되었거나, 이전 URL이 더 이상 없는 경우
        if (url !== detectedUrl) {
            setDetectedUrl(url);
            // URL이 있는 경우 메타데이터 가져오기 (모의 데이터)
            if (url) {
                // 실제 구현에서는 API 호출로 대체
                // fetchLinkMetadata(url).then(data => setLinkPreviewData(data));
                // 모의 데이터
                setTimeout(function() {
                    setLinkPreviewData({
                        url: url,
                        title: "링크 제목 예시",
                        description: "이 링크에 대한 설명이 여기에 표시됩니다. 실제 구현에서는 API에서 메타데이터를 가져옵니다.",
                        image: "https://picsum.photos/800/400",
                        siteName: url.includes("youtube") ? "YouTube" : url.includes("twitter") ? "Twitter" : "웹사이트",
                        type: url.includes("youtube") ? "youtube" : "website"
                    });
                }, 300);
            } else {
                setLinkPreviewData(null);
            }
        }
    }, [
        text,
        detectedUrl
    ]);
    return {
        detectedUrl: detectedUrl,
        linkPreviewData: linkPreviewData,
        setDetectedUrl: setDetectedUrl,
        setLinkPreviewData: setLinkPreviewData
    };
}
